var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showNetworkAlert)?_c('el-alert',{attrs:{"title":_vm.networkStatusText,"type":_vm.networkStatusType,"closable":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }